import { useEffect, useState } from 'react'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { RoleForm } from '@/components/forms/RoleForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditRolePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const roleId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!roleId || Number.isNaN(roleId)) {
      navigate('/user-management/roles', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [roleId, navigate])

  const handleSuccess = () => {
    navigate('/user-management/roles')
  }

  const handleCancel = () => {
    navigate('/user-management/roles')
  }

  if (isValidating || !roleId) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Role</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update role information and permissions
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <RoleForm roleId={roleId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


